import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const KnowledgeCard = ({ title, description, Icon, externalLink }) => {
  const navigate = useNavigate();

  const handleClick = (e, link) => {
    e.preventDefault();
    if (link && link.startsWith('http')) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else if (link) {
      navigate(link);
    }
  };

  return (
    <div 
      className="block bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 hover:-translate-y-1 transform cursor-pointer min-h-[150px] w-full"
      onClick={(e) => handleClick(e, externalLink)}
    >
      <div className="p-4">
        <div className="flex items-center gap-4 mb-2">
          <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center">
            <Icon className="w-6 h-6 text-blue-600 stroke-[1.5]" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 min-h-[48px] flex items-start justify-start">{title}</h3>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">{description}</p>
      </div>
    </div>
  );
};

export default KnowledgeCard;
